// Needs refactoring
// Duplicated logic in the "each" function
var selector = '.citadel_payout_custom_attribute_group';

function updateCitadelPayoutCustomAttributes(countryCode) {
  $(selector + '[data-country*="' + countryCode + '"]').each(function (idx, group) {
    var attributeGroup = $(group);
    attributeGroup.find('label').addClass('required');
    attributeGroup.removeClass('hidden');
  });
  $(selector + ':not([data-country*="' + countryCode + '"])').each(function (idx, group) {
    var attributeGroup = $(group);
    attributeGroup.find('label').removeClass('required');
    attributeGroup.addClass('hidden');
  });
}

function listenForCountryChange() {
  if ($(selector).length === 0) {
    return;
  }

  $('#billing_address_country').on('change', function () {
    var selectedCountry = $(this).val();
    updateCitadelPayoutCustomAttributes(selectedCountry);
  });
}

var CitadelPayout = {
  listenForCountryChange: listenForCountryChange
};
export default CitadelPayout;